import { Log } from '@/shared/Log';
import { R } from '../Texts.resx';
import { ICallQualityFeedbackRequest } from '@/shared/interfaces';
import { AlertViewModel } from '@/knockoutDeprecated/viewModels/AlertViewModel';
import { CallEndedMessage } from '@/features/azureVideo/types';

export const closeWindowOrRedirect = () => {
    if (window.opener) {
        window.opener.postMessage(CallEndedMessage, window.location.origin);
        window.close();
    } else {
        window.location.href = window.location.origin + '/';
    }
};
export function goToDoctorFeedback(props: {
    locator: string;
    videoSessionUid: string;
    azureCallId?: string;
}) {
    let url =
        window.location.origin +
        '/doctor/call/' +
        props.locator +
        '/feedback/' +
        props.videoSessionUid;

    if (props.azureCallId) {
        url += '?azureCallId=' + props.azureCallId;
    }

    window.location.href = url;
}

export function goToPatientFeedback(props: { consultationId: string }) {
    window.location.href =
        window.location.origin +
        '/consultations/' +
        props.consultationId +
        '/rate';
}

type CloseDownProps = {
    consultationId: string;
    videoSessionUid: string;
    azureCallId?: string;
};

export async function closeDown({
    consultationId,
    videoSessionUid,
    azureCallId,
}: CloseDownProps) {
    const request: ICallQualityFeedbackRequest = {
        QualityOk: true,
        QualityBad: false,
        QualityBadSound: false,
        QualityBadVideo: false,
        QualityBadConnection: false,
        QualityNoConnection: false,
        QualityBadUserInterface: false,
        QualityBadOther: false,
        QualityDescription: '',
        AzureCallId: azureCallId,
    };
    const url =
        window.location.origin +
        '/api/doctors/calls/' +
        consultationId +
        '/feedback/' +
        videoSessionUid;

    return fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    }).then(
        (result) => {
            if (!result.ok) {
                Log.error(
                    `Call quality feedback request has failed, http code: ${result.status}`,
                );
            }
            Log.info(`Azure Call cid=${consultationId}: leaveCall`);
            closeWindowOrRedirect();
        },
        (reason) => {
            const alertModal = new AlertViewModel();
            alertModal.openAlert(R.ErrorCallQualityFeedback);
            Log.error(`Call quality feedback request has failed ${reason}`);
        },
    );
}
